var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "graduationAE" },
    [
      _c("div", { staticClass: "cont-box" }, [
        _c(
          "div",
          { staticClass: "classTitle" },
          [_c("Title", { attrs: { text: "任务开题" } })],
          1
        ),
        _c(
          "div",
          { staticClass: "graduation-tab" },
          [
            _c(
              "el-table",
              {
                attrs: {
                  data: _vm.list,
                  headerRowClassName: "uni-primary-table-header",
                  stripe: "",
                  border: "",
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "paper_plan_title",
                    align: "center",
                    label: "计划",
                    "min-width": "120",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "",
                    align: "center",
                    label: "专业任务书",
                    "min-width": "120",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "el-button",
                            {
                              staticClass: "link-btn",
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.taskTitleClick(row)
                                },
                              },
                            },
                            [_vm._v("下载任务书")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "teacher_title",
                    align: "center",
                    label: "指导老师",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "teacher_mobile",
                    align: "center",
                    label: "联系电话",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "score_apply_time",
                    align: "center",
                    label: "交稿截止时间",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "查看任务书",
            visible: _vm.isShowAssignmentLook,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowAssignmentLook = $event
            },
            close: _vm.assignmentLookClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "dialog" },
            _vm._l(_vm.assignmentList, function (item, index) {
              return _c(
                "div",
                { key: index },
                [
                  _c("span", [_vm._v(_vm._s(item.name))]),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "text" },
                      on: {
                        click: function ($event) {
                          return _vm.downloadAssignment(item)
                        },
                      },
                    },
                    [_vm._v("下载")]
                  ),
                ],
                1
              )
            }),
            0
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isShowAssignmentLook = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "openingReport",
          attrs: {
            title: "任务书及开题报告上传",
            visible: _vm.isShowOpeningReport,
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowOpeningReport = $event
            },
            close: _vm.openingReportClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "dialog" },
            [
              _c(
                "el-form",
                {
                  ref: "openingReport",
                  attrs: {
                    model: _vm.openingReportData,
                    rules: _vm.openingReportRules,
                    "label-width": "200px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "设计资料文件:", prop: "files_url" } },
                    [
                      _c("FalConUpload", {
                        ref: "uploadFile",
                        attrs: {
                          listStyle: "text",
                          accept:
                            ".pdf,.zip,.rar,.xls,.xlsx,.doc,.docx,.ppt,.pptx",
                          limit: 20,
                          multiple: true,
                          isFile: true,
                          isAccept: false,
                        },
                        on: {
                          handleRemove: _vm.handleRemoveFile,
                          handleChange: _vm.handleChangeFile,
                        },
                      }),
                      _c("div", { staticClass: "tips" }, [
                        _vm._v("说明：可上传PDF文档，压缩文件或OFFICE文档"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "手写签名:", prop: "sign_img" } },
                    [
                      _c("esignHandle", {
                        ref: "esignHandle",
                        attrs: {
                          selectSignImg: _vm.openingReportData.sign_img,
                        },
                        on: {
                          "update:selectSignImg": function ($event) {
                            return _vm.$set(
                              _vm.openingReportData,
                              "sign_img",
                              $event
                            )
                          },
                          "update:select-sign-img": function ($event) {
                            return _vm.$set(
                              _vm.openingReportData,
                              "sign_img",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "是否需要取得学位:", prop: "is_degree" },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: {
                            size: "small",
                            fill: "#67C23A",
                            label: "size control",
                          },
                          model: {
                            value: _vm.openingReportData.is_degree,
                            callback: function ($$v) {
                              _vm.$set(_vm.openingReportData, "is_degree", $$v)
                            },
                            expression: "openingReportData.is_degree",
                          },
                        },
                        [
                          _c("el-radio-button", { attrs: { label: 1 } }, [
                            _vm._v("是"),
                          ]),
                          _c("el-radio-button", { attrs: { label: 0 } }, [
                            _vm._v("否"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.openingReportData.is_degree == 1
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "英语合格证照片", prop: "img1" },
                            },
                            [
                              _c("FalConUpload", {
                                ref: "uploadimg1",
                                attrs: { isShowModal: false },
                                on: {
                                  handleRemove: _vm.img1HandleRemove,
                                  handleChange: _vm.img1HandleChange,
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "计算机合格证照片",
                                prop: "img2",
                              },
                            },
                            [
                              _c("FalConUpload", {
                                ref: "uploadimg2",
                                attrs: { isShowModal: false },
                                on: {
                                  handleRemove: _vm.img2HandleRemove,
                                  handleChange: _vm.img2HandleChange,
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "成绩单照片", prop: "img3" } },
                            [
                              _c("FalConUpload", {
                                ref: "uploadimg3",
                                attrs: { isShowModal: false },
                                on: {
                                  handleRemove: _vm.img3HandleRemove,
                                  handleChange: _vm.img3HandleChange,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "text-align": "center" } },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isShowOpeningReport = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.openingReportSubmit },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }